/* eslint-disable import/no-named-as-default */
/** @file Main AppShell for Merchant Portal */

import React from 'react';
import { Outlet } from 'react-router-dom';
import { Drawer, Box, IconButton, useMediaQuery } from '@mui/material';
import { Menu } from '@mui/icons-material';

import { automationIds } from '../util/constants';
import { NavContent } from './components/NavContent';

import { useTokenRemoval } from '../hooks';
import { useMainContent } from '../contexts/MainContentContext';
import { useMerchant } from '../contexts/MerchantContext';
import appTheme from '../styles/themes/theme';

export const NAV_DRAWER_WIDTH = '265px';

const AppShell = (): JSX.Element => {
  const { mainContentRef } = useMainContent();
  const { hasMerchantAccess } = useMerchant();
  const showConfigurationNav = hasMerchantAccess();

  const isMobile = useMediaQuery(appTheme.breakpoints.down('md'));
  const [drawerIsOpen, setDrawerIsOpen] = React.useState(false);

  useTokenRemoval();

  return (
    <Box sx={{ display: 'flex', flexGrow: 1, width: '100%' }}>
      {showConfigurationNav && isMobile && (
        <IconButton
          aria-label="menu"
          onClick={() => setDrawerIsOpen(true)}
          sx={{
            position: 'absolute',
            padding: 1,
            marginLeft: 1,
            marginTop: 1,
            backgroundColor: 'secondary.light',
            borderRadius: '4px',
          }}
        >
          <Menu />
        </IconButton>
      )}
      {showConfigurationNav && (
        <Drawer
          sx={{ zIndex: 10 }}
          data-testid={automationIds.SIDEBAR}
          variant={isMobile ? 'temporary' : 'permanent'}
          onClose={() => setDrawerIsOpen(false)}
          open={!isMobile || drawerIsOpen}
          PaperProps={{
            sx: {
              position: 'relative',
              width: NAV_DRAWER_WIDTH,
              zIndex: 1,
            },
          }}
        >
          <NavContent onCloseDrawer={() => setDrawerIsOpen(false)} />
        </Drawer>
      )}
      <Box component="main" ref={mainContentRef} sx={{ flexGrow: 1, overflow: 'auto' }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default AppShell;
